import { SupplierEntrySchema } from '#app/routes/mocra+/_form+/components/suppliers/schema.ts'
import {
	collectSupplierErrors,
	createSupplierDraft,
	sanitizeSupplierDraft,
	supplierDraftToEntry,
	supplierEntryToDraft,
	type SupplierDraft,
} from '#app/routes/mocra+/_form+/components/suppliers/types.ts'
import { assertEntityDefinition } from '#app/routes/mocra+/_form+/entity-definition.ts'

export const supplierDefinition = assertEntityDefinition({
	schema: SupplierEntrySchema,
	createDraft: () => createSupplierDraft(),
	sanitizeDraft: sanitizeSupplierDraft,
	serialize: supplierDraftToEntry,
	deserialize: supplierEntryToDraft,
	collectErrors: collectSupplierErrors,
})

export type SupplierEntityDraft = SupplierDraft
